import React from 'react';
import { EmojiPicker } from 'frimousse';

type Props = {
  /** Current emoji, if any. Used to decide whether to show the Remove button. */
  emoji: string | null;
  onSelect: (emoji: string) => void;
  onRemove: () => void;
};

export const AgentEmojiPicker: React.FC<Props> = ({
  emoji,
  onSelect,
  onRemove,
}) => {
  const hasEmoji = emoji !== null && emoji !== '';
  return (
    <EmojiPicker.Root
      className="isolate flex h-[280px] w-fit flex-col bg-popover"
      onEmojiSelect={({ emoji: next }) => onSelect(next)}
    >
      <div className="relative z-10 flex items-center gap-2 bg-popover px-2 pt-2 pb-2 after:pointer-events-none after:absolute after:inset-x-0 after:top-full after:h-1 after:bg-popover">
        <EmojiPicker.Search
          className="flex-1 appearance-none rounded-md border border-border bg-secondary/40 px-2.5 py-2 text-sm outline-none focus:border-foreground/30 [&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-decoration]:appearance-none"
          placeholder="Search emoji…"
        />
        {hasEmoji ? (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onRemove();
            }}
            className="shrink-0 rounded-md px-2 py-1.5 text-xs text-muted-foreground hover:bg-secondary"
          >
            Remove
          </button>
        ) : null}
      </div>
      <EmojiPicker.Viewport className="relative flex-1 outline-hidden">
        <EmojiPicker.Loading className="absolute inset-0 flex items-center justify-center text-sm text-muted-foreground">
          Loading…
        </EmojiPicker.Loading>
        <EmojiPicker.Empty className="absolute inset-0 flex items-center justify-center text-sm text-muted-foreground">
          No emoji found.
        </EmojiPicker.Empty>
        <EmojiPicker.List
          className="select-none pb-1.5"
          components={{
            CategoryHeader: ({ category, ...props }) => (
              <div
                {...props}
                className="bg-popover px-3 pt-3 pb-1.5 text-xs font-medium text-muted-foreground"
              >
                {category.label}
              </div>
            ),
            Row: ({ children, ...props }) => (
              <div {...props} className="scroll-my-1.5 px-1.5">
                {children}
              </div>
            ),
            Emoji: ({ emoji: e, ...props }) => (
              <button
                {...props}
                className="flex size-10 items-center justify-center rounded-md text-2xl leading-none data-[active]:bg-secondary"
              >
                {e.emoji}
              </button>
            ),
          }}
        />
      </EmojiPicker.Viewport>
    </EmojiPicker.Root>
  );
};
